import { render, staticRenderFns } from "./ForAws.component.vue?vue&type=template&id=54c3c166&scoped=true&"
import script from "./ForAws.component.vue?vue&type=script&lang=js&"
export * from "./ForAws.component.vue?vue&type=script&lang=js&"
import style0 from "./ForAws.component.vue?vue&type=style&index=0&id=54c3c166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c3c166",
  null
  
)

export default component.exports